export default __webpack_public_path__ + "static/media/electromecanica.54718627.jpg";